import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UserModel } from 'src/app/models/user.model';
import { AuthService } from 'src/app/services/auth.service';
import { EventService } from 'src/app/services/event.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css'],
})
export class ChangePasswordComponent implements OnInit {
  changePassForm!: FormGroup;
  emailForm!: FormGroup;
  entityLogo!: string;
  pageTitle: string = 't-change-password';
  submited: boolean = false;
  isDisabled: boolean = false;
  sendEmail: boolean = false;
  noEmail: boolean = false;
  emailToSend: any;
  currentUser: UserModel = this.authService?.currentUserValue;

  constructor(
    private eventService: EventService,
    private formBuilder: FormBuilder,
    private router: Router,
    private authService: AuthService
  ) {
    if (this.currentUser) {
      this.sendEmail = true;
    }
  }

  ngOnInit(): void {
    this.eventService.broadcast('header-page-title', this.pageTitle);
    const entityData: any = localStorage.getItem('entityData');

    this.entityLogo = JSON.parse(entityData).logo;
    this.emailForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    });
    if (this.currentUser) {
      this.changePassForm = this.formBuilder.group({
        password: ['', [Validators.required]],
        confirmPassword: ['', Validators.required],
        oldPass: ['', [Validators.required]],
      });
    } else {
      this.changePassForm = this.formBuilder.group({
        password: ['', [Validators.required]],
        confirmPassword: ['', Validators.required],
        confirmCode: ['', [Validators.required]],
      });
    }
  }

  get formEmail() {
    return this.emailForm.controls;
  }

  get form() {
    return this.changePassForm.controls;
  }

  sendCode() {
    this.submited = true;
    if (this.emailForm.invalid) {
      return;
    } else {
      this.isDisabled = true;
      this.authService
        .sendCodeToChangePass(this.formEmail['email'].value)
        .subscribe({
          next: (result: any) => {
            this.isDisabled = false;
            this.submited = false;
            this.sendEmail = true;
          },
          error: (err: any) => {
            this.isDisabled = false;
          },
        });
    }
  }

  changePass() {
    this.submited = true;
    // stop here if form is invalid
    if (this.changePassForm.invalid) {
      return;
    } else {
      if (this.passwordMatch()) {
        this.isDisabled = true;
        if (this.currentUser) {
          this.authService
            .changePassword(
              this.form['oldPass'].value,
              this.form['password'].value
            )
            .subscribe({
              next: (result: any) => {
                this.isDisabled = false;
                this.submited = false;
                if (this.authService.currentUserValue) {
                  this.router.navigateByUrl('/');
                } else {
                  this.router.navigateByUrl('/account/login');
                }
              },
              error: (err: any) => {
                this.isDisabled = false;
                this.changePassForm.controls['oldPass'].setErrors({
                  invalidCredentials: true,
                });
              },
            });
        } else {
          this.authService
            .changePasswordCode(
              this.formEmail['email'].value,
              this.form['password'].value,
              this.form['confirmCode'].value
            )
            .subscribe({
              next: (result: any) => {
                this.isDisabled = false;
                this.submited = false;
                if (this.authService.currentUserValue) {
                  this.router.navigateByUrl('/');
                } else {
                  this.router.navigateByUrl('/account/login');
                }
              },
              error: (err: any) => {
                this.isDisabled = false;
                this.changePassForm.controls['confirmCode'].setErrors({
                  incorrectCode: true,
                });
              },
            });
        }
      }
    }
  }

  passwordMatch() {
    if (this.form['password'].value !== this.form['confirmPassword'].value) {
      this.changePassForm.controls['confirmPassword'].setErrors({
        diferentPass: true,
      });
      return false;
    }
    return this.changePassForm.valid &&
      this.form['password'].value === this.form['confirmPassword'].value
      ? true
      : false;
  }
}
